module.exports = __webpack_public_path__ + "img/production_cruiser.a6903834.jpg";